import { render, staticRenderFns } from "./DebitCardImageUpload.vue?vue&type=template&id=68ac1217&scoped=true"
import script from "./DebitCardImageUpload.vue?vue&type=script&lang=ts"
export * from "./DebitCardImageUpload.vue?vue&type=script&lang=ts"
import style0 from "./DebitCardImageUpload.vue?vue&type=style&index=0&id=68ac1217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac1217",
  null
  
)

export default component.exports